import { createSlotRecipe } from './runtime.js';

const chatWelcomeConfig = {"name":"chatWelcome","slots":["root","message","suggestions"]}

export const chatWelcome = /* @__PURE__ */ createSlotRecipe(chatWelcomeConfig)